import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {  Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _moment from 'moment';
import { ClassAddUserMasters } from './class-add-user-masters';
import { map} from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import {AppComponent} from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
import { Company } from '../company-master/company-master.component';
export interface CompanyDetails {
  ID: string;
  Name: string;
}
export interface DepartmentDetail {
  hdID: string;
  MainDescr: string;
}
export class FetchCommunityData {
  AllocateUser: string;
  AllocateUnPaidUser: string;
  ConsumedPaidUser: string;
  ConsumedUser: string;
}

@Component({
    selector: 'app-add-user-masters',
    templateUrl: './add-user-masters.component.html',
    styleUrls: ['./add-user-masters.component.css'],
    standalone: false
})
export class AddUserMastersComponent implements OnInit {
  ADDUserMaster: FormGroup;
  DownloadURL: string;
  url: string;
  id: any;
  pageurl: string;
  Region: string;
  Designation: string;
  Department: string;
  User: string;
  Branch: string;
  CompanyList: CompanyDetails[] = [];
  DepartmentList: DepartmentDetail[] = [];
  selectedCompany = [];
  selectedDepartment = [];
  Role: string;
  ButtonCaption: string;
  getdata: string;
  RightsID: string;
  RouteCompanyMaster: string;
  RouteGMDepartment: string;
  RouteGMRegion: string;
  RouteGMBranch: string;
  RouteGMDesignation: string;
  RouteUserMaster: string;
  UserStatusRecord: any;
  submitted: boolean;
  AllocateUser: any;
  AllocateUnPaidUser: any;
  ConsumedPaidUser: any;
  ConsumedUser: any;
  totalUser:any;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, protected alertService: AlertService) {
    this.url = AppComponent.baseURL;
    this.DownloadURL = AppComponent.DownloadURL;
  }

  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202040001') || this.RightsID.includes('202040021') || this.RightsID.includes('202040000')) {
    } else {
      window.location.href = "module/0";
    }
    this.UserStatusRecord=1;
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.id = pagehead[2];

    this.getMasterData();
    this.fetchRouteDataRights();
    this.ADDUserMaster = this.formBuilder.group({
      UserName: ['', Validators.required], email: ['', [ Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'), Validators.required]],
      MobileNumber: ['', Validators.required], AlternateMobile: [''], Designation: [''], Manager: [''],ManagerL2: [''], Status: [''],
      loginName: ['', Validators.required], FunctionalRole: ['', Validators.required], Company: ['', Validators.required], Department: ['', Validators.required], Region: [''], Branch: [''], IsPaid: [''] });
    this.ADDUserMaster.patchValue({
      Status: '1' , IsPaid: '1',  Designation: '0', Manager: '0', ManagerL2: '0',FunctionalRole: '0', Region: '0', Branch: '0' });
    if (this.id == 0) { this.ButtonCaption = 'Add'; } else { this.ButtonCaption = 'Update'; this.fetchExistingUserDetail(); }
    if (this.id > 0) {
      this.ADDUserMaster = this.formBuilder.group({
        UserName: [''], email: ['', [ Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
        MobileNumber: [''], AlternateMobile: [''], Designation: [''], Manager: [''],ManagerL2: [''], Status: [''],
        loginName: [''], FunctionalRole: [''], Company: [''], Department: [''], Region: [''], Branch: [''],
       IsPaid: [{value: 0, disabled: true}] });
    }
  }
  get f() { return this.ADDUserMaster.controls; }
 fetchRouteDataRights() {
  // tslint:disable-next-line: max-line-length
  this.RouteUserMaster = this.RightsID.includes('202040000') || this.RightsID.includes('202040001') || this.RightsID.includes('202040021') ? 'user-master/0' : 'module/0';
  // tslint:disable-next-line: max-line-length
  this.RouteCompanyMaster = this.RightsID.includes('202044000') || this.RightsID.includes('202044001') || this.RightsID.includes('202044021') ? 'navcompany/company/0' : 'module/0';
  if (this.RightsID.includes('202042000') || this.RightsID.includes('202042001') || this.RightsID.includes('202042021')) {
   this.RouteGMRegion = "general-master/085";
   this.RouteGMBranch = "general-master/090";
   this.RouteGMDepartment = "general-master/030";
   this.RouteGMDesignation = "general-master/035";
  } else {
    this.RouteGMRegion = "module/0";
    this.RouteGMBranch = "module/0";
    this.RouteGMDepartment = "module/0";
    this.RouteGMDesignation = "module/0";
  }
  }
  getMasterData() {
     this.getMaster('085', '') .subscribe( (data: any) => { this.Region = data; });

     this.http.get(this.url + 'Notice/GetCompanyMasterList').pipe(map(data => data = ( data == null ? null : JSON.parse(data.toString()))))
      .subscribe( (data: any) => { this.CompanyList = data;  });

     this.getMaster('030', '') .subscribe( (data: any) => { this.DepartmentList = data; });

     this.getMaster('035', '') .subscribe( (data: any) => { this.Designation = data; });

     this.getSysData('015') .subscribe( (data: any) => { this.Role = data;  });

     if (this.id == 0) {
      this.http.get(this.url + 'GM/GetEmployee') .subscribe( (data) => { this.User = JSON.parse(data.toString()); });
     } else {
      this.http.get(this.url + 'GM/GetEmployee?id=' + this.id) .subscribe( (data) => { this.User = JSON.parse(data.toString()); });
     }

 }

 getSysData(GID: string) {
  return this.http.get(this.url + 'SysData/GetSysData?GenID=' + GID )
  .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
  }

 getMaster(GID: string, MID: string) {
   return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
   .pipe(map(data => data = ( data == null ? null : JSON.parse(data.toString()))));
   }

  onRegionSelect(GenID) {
    this.getMaster('090', GenID).subscribe( (data: any) => { this.Branch = data ; });
  }
  fetchExistingUserDetail() {
    this.http.get(this.url + 'User/FetchUserMaster?ID=' + this.id)
    .subscribe( (data) =>   {
        if (data == null) {
          this.alertService.showError('No Record available');
        } else {
          const classAddUserMasters: ClassAddUserMasters = JSON.parse(data.toString())[0];

          if (classAddUserMasters.Region != null) {
            this.getMaster('090', classAddUserMasters.Region.toString()).subscribe( (data: any) => {
              this.Branch = data ; }); }
              this.UserStatusRecord=classAddUserMasters.recEnable.toString() == "true" ? 1 : 0;
          this.ADDUserMaster.patchValue({
            Status: classAddUserMasters.recEnable.toString() == "true" ? '1' : '0', UserName: classAddUserMasters.UserName,
            email: classAddUserMasters.Email,
            MobileNumber: classAddUserMasters.Mobile, AlternateMobile: classAddUserMasters.AlternateMobile,
            Designation: classAddUserMasters.Designation == null ? 0 : +classAddUserMasters.Designation,
            Manager: classAddUserMasters.ManagerID == null ? 0 : classAddUserMasters.ManagerID,
            ManagerL2: classAddUserMasters.ManagerL2ID == null ? 0 : classAddUserMasters.ManagerL2ID,
             loginName: classAddUserMasters.LoginName,
            FunctionalRole: classAddUserMasters.RoleID == null ? 0 : classAddUserMasters.RoleID.toString()
            , Region: classAddUserMasters.Region == null ? 0 : classAddUserMasters.Region,
            Branch: classAddUserMasters.Branch == null ? 0 : classAddUserMasters.Branch,
            IsPaid: classAddUserMasters.IsPaid.toString(),
            Department: classAddUserMasters.DeptApplicable?.toString()?.split(',')?.map(Number),
            Company: classAddUserMasters?.CompanyApplicable?.toString()?.split(',')?.map(Number)
          });
        }
       }
    );
  }


  onUserMasterFormSubmit(FormData) {
    if(this.ADDUserMaster.invalid){
      this.ADDUserMaster.markAllAsTouched();
      return;
    }
    this.http.get(this.url + 'CommunityDetail/FetchCommunityDetail')
    .subscribe( (data1) =>   {
        if (data1 == null) {  } else {
          const CommunityData: FetchCommunityData = JSON.parse(data1.toString())[0];
          this.AllocateUser= +CommunityData.AllocateUser;
          this.AllocateUnPaidUser= +CommunityData.AllocateUnPaidUser;
          this.ConsumedPaidUser= +CommunityData.ConsumedPaidUser;
          this.ConsumedUser= +CommunityData.ConsumedUser;
    if(this.id>0){
      if(this.UserStatusRecord<+FormData.Status){
        if(FormData.IsPaid==1){
          if(this.ConsumedPaidUser>=this.AllocateUser){
            this.alertService.showError('For More Paid User , Contact Adminstrator');
            return;
          }
        } else {
          if(this.ConsumedUser>=this.AllocateUnPaidUser){
            this.alertService.showError('For More Un-Paid User , Contact Adminstrator');
            return;
          }
        }
      }
    }
    else{
      if(FormData.IsPaid==1){
        if(this.ConsumedPaidUser>=this.AllocateUser){
          this.alertService.showError('For More Paid User , Contact Adminstrator');
          return;
        }
      } else {
        if(this.ConsumedUser>=this.AllocateUnPaidUser){
          this.alertService.showError('For More Paid Un-User , Contact Adminstrator');
          return;
        }
      }
    }

    if (FormData.UserName == "" || FormData.UserName == null) {
      this.alertService.showWarning('Please Enter User Name'); return; }
    if (FormData.loginName == "" || FormData.loginName == null) {
      this.alertService.showWarning('Please Enter Login Name'); return; }
    if (FormData.MobileNumber == "" || FormData.MobileNumber == null) {
      this.alertService.showWarning('Please Enter Mobile Number'); return; }
    if (FormData.email == "" || FormData.email == null) {
      this.alertService.showWarning('Please Enter Email'); return;
      }  else {
       if (this.ADDUserMaster.invalid) {
        this.alertService.showWarning('Please Enter Correct Email');
         return;
        }
       let classAddUserMasters: ClassAddUserMasters = {
        ID: this.id,
        ManagerID: FormData.Manager,
        ManagerL2ID: FormData.ManagerL2,
        LoginName: FormData.loginName,
        UserName: FormData.UserName,
        Email: FormData.email,
        Designation: FormData.Designation,
        RoleID: FormData.FunctionalRole,
        DeptApplicable: FormData.Department.toString(),
        CompanyApplicable: FormData.Company.toString(),
        Mobile: FormData.MobileNumber,
        AlternateMobile: FormData.AlternateMobile,
        Region: FormData.Region,
        Branch: FormData.Branch,
        recEnable: FormData.Status,
        IsPaid: FormData.IsPaid
       };
       this.http.post(this.url + 'User/insertUpdateUserMaster', classAddUserMasters) .subscribe( (data) => {
        this.alertService.showSuccess(data.toString());
           });
        }
      }});
 }
}
